import { Routes } from '@angular/router';

export const RESERVATION_ROUTES: Routes = [
  {
    path: 'reservations',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@pages/reservation/reservation-directory/reservation-directory.component').then(
            (c) => c.ReservationDirectoryComponent,
          ),
        data: { layout: 'private' },
      },
    ],
  },
];
